module.exports = __webpack_public_path__ + "img/people_active.9821ddd6.svg";